import { useMutation } from '@apollo/client';
import { ResetPasswordRequestInput } from '../../shared/types';
import {
    CITRIN_RESET_PASSWORDREQUEST,
    CreateResetPasswordRequestRequest,
    CreateResetPasswordRequestResponse,
} from '..';

type CreateMutationFunction = (request: ResetPasswordRequestInput) => Promise<String>;
export const useResetPasswordRequestMutation = (): { mutation: CreateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<CreateResetPasswordRequestResponse, CreateResetPasswordRequestRequest>(
        CITRIN_RESET_PASSWORDREQUEST
    );
    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_resetPasswordRequest;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
